import usePublicSettings from "../lib/usePublicSettings";

import { tr } from "../lib/i18n";
/** Renders the public site only when it is enabled; otherwise one neutral notice page. */
export default function PublicGate({ children }) {
  const { enabled, suspended, loading } = usePublicSettings();
  if (loading) return <div style={{ minHeight: "100vh" }} data-testid="public-gate-loading" />;
  if (!enabled) {
    return (
      <main
        data-testid="site-unavailable"
        style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 24, background: "#f4f3f1", color: "#1c1c1e", fontFamily: "Outfit, system-ui, sans-serif", textAlign: "center" }}
      >
        <h1 data-testid="site-unavailable-message" style={{ fontSize: 24, fontWeight: 400, margin: 0 }}>
          {suspended ? tr("lic.site_temporarily_unavailable") : tr("x.this_website_is_currently_unavailable")}
        </h1>
      </main>
    );
  }
  return children;
}
